import React, { createContext, useContext } from 'react';
import { useLiveChat } from '../Hooks/useLiveChat';

const LiveChatContext = createContext(null);

export const LiveChatProvider = ({ children }) => {
  const liveChat = useLiveChat();

  return (
    <LiveChatContext.Provider value={liveChat}>
      {children}
    </LiveChatContext.Provider>
  );
};

export const useLiveChatContext = () => {
  const context = useContext(LiveChatContext);
  if (!context) {
    throw new Error('useLiveChatContext must be used within LiveChatProvider');
  }
  return context;
};
